import React, {useContext, useEffect, useState} from 'react';
import Seo from "../components/Seo/Seo";
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import Slider from "react-slick";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCity,
    faClock,
    faHourglass,
    faLanguage,
    faLocationDot,
    faPerson,
    faChildReaching,
    faPercent,
    faMountainCity,
} from '@fortawesome/free-solid-svg-icons';
import {Link, useNavigate, useParams} from "react-router-dom";
import {handleAvailableDatesFormat, handleImageUrl} from "../helpers";
import { checkDateAvailability } from "../utils/dateAvailability";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { de } from 'date-fns/locale';
import {LangContext} from "../App";
import {axios} from "../axios";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {getTranslation} from "../translations";


const AbroadPage = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const [selectedLanguage,setSelectedLanguage] = useState('')
    const [startingTime,setStartingTime] = useState('')
    const lang = useContext(LangContext)
    const navigate = useNavigate()
    useEffect(()=>{
        axios.get(`${lang}/abroad/${id}`)
            .then(res => setData(res.data))
    },[id,lang])
    const [startDate, setStartDate] = useState(null);
    const [availableDateRanges,setAvailableDateRanges] = useState([
        {
            start: new Date(),
            end: new Date(),
        },
    ])
    const [sliderSettings,setSlidersettings] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false,
        customPaging: (i) => <div style={{backgroundImage:`url(${i})`}}></div>,
    })
    const [guestCount,setGuestCount] = useState()
    const [childCount,setChildCount] = useState()
    useEffect(()=>{
        let images = data?.images.split(',')
        if(images){
            images.pop()
            let sliderData = {...sliderSettings,customPaging:(i) => {
                    return (
                        <div style={{backgroundImage: `url(${handleImageUrl(images[i])})`}}></div>
                    )
                }}
            setSlidersettings(sliderData)
        }
        if(data?.available_dates){
            setAvailableDateRanges(handleAvailableDatesFormat(data?.available_dates))
        }

    },[data])
    const handleDateChange = (date) => {
        setStartDate(date);
    };
    const isDateAvailable = (date) => {
        return checkDateAvailability(date, data, availableDateRanges);
    };
    const handleSliderImages = ()=>{
        let images = data?.images.split(',')
        if(images){
            images?.pop()
            return images.map((img) => {
                return (
                    <div className='slider-image-wrapper'>
                        <img src={handleImageUrl(img)} alt={data?.title}/>
                    </div>
                )
            })
        }
    }
    const handlePrice = ()=>{
        let result = 0
        if(guestCount){
            result += guestCount * data?.price
        }
        if(childCount){
            result += childCount * data?.child_price
        }
        if(data?.discount){
            let discount = (result * data?.discount) / 100
            result = result - discount
        }
        return ` ${result}$`
    }
    const handleBook = (url)=>{
        const count = Number(guestCount) + Number(childCount)
        if(count > data?.guest_max){
            alert(`${getTranslation(lang,'maxParticipants')} ${data?.guest_max}.`)
        }else if(count < data?.guest_min){
            alert(`${getTranslation(lang,'minParticipants')} ${data?.guest_min} ${getTranslation(lang,'minParticipantsSuffix')}`)
        }else if(!selectedLanguage){
            alert(getTranslation(lang,'pleaseChooseLanguage'))
        }else if(!startingTime){
            alert(getTranslation(lang,'pleaseChooseStartingTime'))
        }else if(!startDate){
            alert(getTranslation(lang,'pleaseChooseDate'))
        }else{
            navigate(url)
        }
    }
    const handleLanguage = (event) => {
        setSelectedLanguage(event.target.value)
    };
    const handleStartingTime = (event) => {
        setStartingTime(event.target.value)
    };
    if(!data){
        return <p>{getTranslation(lang,'loading')}</p>
    }else{
        return (
            <div className='tour-page'>
                <Seo
                    pageKey="lesserArmenia"
                    title={data?.title}
                    description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)}
                />
                <div className="center-wrapper">
                    <main>
                        <div className="row w-100">
                            <div className="col-lg-8">
                                <div className="tour-info">
                                    <div className="tour-image">
                                        <Slider {...sliderSettings}>
                                            {handleSliderImages()}
                                        </Slider>
                                    </div>
                                    <h1 className="tour-title">{data?.title}</h1>
                                    <div className="tour-details-wrapper">
                                        <div className="row">
                                            <div className="col-6">
                                                {data?.region &&
                                                    <p className='text-capitalize'>
                                                        <div className='svg-wrapper'>
                                                            <FontAwesomeIcon icon={faLocationDot} className='me-3'/>
                                                        </div>
                                                        <b>{getTranslation(lang,'region')}:</b>
                                                        {data?.region}
                                                    </p>}
                                                {data?.country &&
                                                    <p className='text-capitalize'>
                                                        <div className='svg-wrapper'>
                                                            <FontAwesomeIcon icon={faCity} className='me-3'/>
                                                        </div>
                                                        <b>{getTranslation(lang,'country')}:</b>
                                                        {data?.country}
                                                    </p>}
                                                {data?.city &&
                                                    <p className='text-capitalize'>
                                                        <div className='svg-wrapper'>
                                                            <FontAwesomeIcon icon={faMountainCity} className='me-3'/>
                                                        </div>
                                                        <b>{getTranslation(lang,'city')}:</b>
                                                        {data?.city}
                                                    </p>}
                                            </div>
                                            <div className="col-6">
                                                <p>
                                                    <div className='svg-wrapper'>
                                                        <FontAwesomeIcon icon={faHourglass} className='me-3'/>
                                                    </div>
                                                    <b>{getTranslation(lang,'tourDuration')}:</b>
                                                    {data?.duration_day && <span className='me-1'>{`${data?.duration_day} ${getTranslation(lang,'day')}`}</span>}
                                                    {data?.duration_hour && <span className='me-1'>{`${data?.duration_hour} ${getTranslation(lang,'hour')}`}</span>}
                                                    {data?.duration_minute && <span className='me-1'>{`${data?.duration_minute} ${getTranslation(lang,'minute')}`}</span>}
                                                </p>
                                                <p>
                                                    <div className='svg-wrapper'>
                                                        <FontAwesomeIcon icon={faLocationDot} className='me-3'/>
                                                    </div>
                                                    <b>{getTranslation(lang,'meetingPoint')}:</b> {data?.meeting}
                                                    <br/>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="main-text" dangerouslySetInnerHTML={{__html:data?.text}}></div>
                                </div>
                            </div>
                                <div className="col-lg-4 p-1">
                                    <div className="sidebar">
                                        <div className="d-flex flex-column">
                                            <h5 className='mb-4  p-2 ps-3 bg-body rounded-3'>{getTranslation(lang, 'guestCount')}</h5>
                                            <div className="tour-details-wrapper mb-3">
                                                <p>
                                                    <div className='svg-wrapper'>
                                                        <FontAwesomeIcon icon={faPerson} className='me-3'/>
                                                    </div>
                                                    <b>{getTranslation(lang, 'price')}:</b> $ {data?.price}
                                                </p>
                                                <p>
                                                    <div className='svg-wrapper'>
                                                        <FontAwesomeIcon icon={faChildReaching} className='me-3'/>
                                                    </div>
                                                    <b>{getTranslation(lang, 'child')}:</b> $ {data?.child_price}
                                                </p>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <div className='d-flex align-items-center mb-3'>
                                                    <span className='me-3'>{getTranslation(lang, 'adults')}: &nbsp;</span>
                                                    <input type="number"
                                                           value={guestCount}
                                                           min='1'
                                                           onChange={e => setGuestCount(Number(e.target.value))}
                                                           className='input-group w-25 ps-1 ms-2'
                                                           placeholder='0'/>
                                                </div>
                                                <div className='d-flex align-items-center'>
                                                    <span className='me-3'>{getTranslation(lang, 'children')}:</span>
                                                    <input type="number"
                                                           value={childCount}
                                                           min='1'
                                                           onChange={e => setChildCount(Number(e.target.value))}
                                                           className='input-group w-25 ps-1'
                                                           placeholder='0'/>
                                                </div>
                                            </div>
                                        </div>
                                        <Box sx={{ minWidth: 120,
                                            '& *':{
                                                textTransform:'capitalize'
                                            }
                                        }} mt={2}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">{getTranslation(lang, 'selectLanguage')}</InputLabel>
                                                <Select
                                                    value={selectedLanguage}
                                                    onChange={handleLanguage}
                                                    label={getTranslation(lang, 'selectLanguage')}
                                                >
                                                    {data?.languages && data.languages.split(',').map(e=>{
                                                        return (
                                                            <MenuItem value={e} sx={{textTransform:'capitalize'}}>{getTranslation(lang, e.trim().toLowerCase())}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box sx={{ minWidth: 120 }} mt={2}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">{getTranslation(lang, 'startingTime')}</InputLabel>
                                                <Select
                                                    value={startingTime}
                                                    onChange={handleStartingTime}
                                                    label={getTranslation(lang, 'startingTime')}
                                                >
                                                {data?.starting_time && data.starting_time.split(';').map(e=>{
                                                    return (
                                                        <MenuItem value={e}>{e}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <div className="d-flex mt-3 datePicker">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleDateChange}
                                            inline
                                            minDate={new Date()}
                                            locale={lang === 'de' ? de : undefined}
                                            filterDate={(date) => isDateAvailable(date)}
                                        />
                                    </div>
                                    {data?.inclusions && <div className="d-flex flex-column">
                                        <h5 className='mb-4  p-2 ps-3 bg-body rounded-3 mt-4'>{getTranslation(lang, 'inclusions')}</h5>
                                        <ul className='inclusions-list'>
                                            {
                                                data?.inclusions.split(';').map((e) => {
                                                    return <li className=' mb-2'>{e}</li>
                                                })
                                            }
                                        </ul>
                                    </div>}
                                    {data?.discount && <div><b>{getTranslation(lang, 'discount')}:</b> {data?.discount}%</div>}
                                    <div className="d-flex flex-column mt-3">
                                        <h5>{getTranslation(lang, 'totalPrice')}:
                                            <span className='text-success'>
                                            {handlePrice()}
                                        </span>
                                        </h5>
                                    </div>
                                    <Link onClick={()=> handleBook(`/booking/abroad/${id}/${startDate}/${handlePrice()}/${guestCount}/${childCount}/${selectedLanguage}/${startingTime}`)}
                                          className="btn btn-primary mt-3 w-100">{getTranslation(lang, 'bookNow')}</Link>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }

};

export default AbroadPage;